import { useLazyQuery } from '@ocp/graphql-client';
export const TOOLBAR_CONTENT_QUERY = `
  query contentToolbar($contentIds: [String], $deviceType: String, $panelMode: String) {
    contentToolbar(contentIds: $contentIds, deviceType: $deviceType, panelMode: $panelMode) {
      items {
        contentClassNameId
        contentClassPk
        showActions
        favoriteButton {
          pressed
          order
          canHiding
        }
        subscriptionButton {
          pressed
          order
          canHiding
        }
        collapseToggler {
          order
          canHiding
        }
        printButton {
          order
          canHiding
          previewUrl
        }
        conversionsButton {
          order
          canHiding
          conversions {
            format
            url
          }
        }
        shareButton {
          order
          canHiding
          countButtonsToMerge
          contentLinkButton {
            url
            order
            canHiding
          }
          sendToEmailButton {
            order
            canHiding
          }
          sendToSmsButton {
            order
            canHiding
          }
        }
        checkOutButton {
          order
          canHiding
          pressed
          url
        }
        openLinkButton {
          url
          order
          canHiding
        }
        addToComparisonListButton {
          comparisonPageUrl
          order
          canHiding
          pressed
        }
        editButton {
          url
          order
          canHiding
        }
      }
      page
      pageSize
      totalCount
    }
  }
`;
const useToolbarContentQuery = () => {
    return useLazyQuery(TOOLBAR_CONTENT_QUERY);
};
export default useToolbarContentQuery;
